module.exports = __webpack_public_path__ + "img/jump-icon.3f4f41d9.svg";